const UtensilsIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Plate */}
      <ellipse cx="20" cy="24" rx="14" ry="5" stroke="currentColor" strokeWidth="1.75" />
      <ellipse cx="20" cy="23" rx="9" ry="3" stroke="currentColor" strokeWidth="1.5" opacity="0.45" />
      {/* Fork */}
      <path
        d="M11 6v6c0 1.5 1 2.5 2.5 2.5S16 13.5 16 12V6"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.5 14.5V20" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path d="M11 6v3M13.5 6v3M16 6v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Knife */}
      <path
        d="M26 6c1.2 2 2 5 2 8.5 0 2-.8 3.5-2 3.5s-2-1.5-2-3.5c0-3.5.8-6.5 2-8.5z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M26 18v8" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
};

export default UtensilsIcon;
